import { render } from "./LegoBoxStatus.vue?vue&type=template&id=0e2b2264"
import script from "./LegoBoxStatus.vue?vue&type=script&lang=js"
export * from "./LegoBoxStatus.vue?vue&type=script&lang=js"

import "./LegoBoxStatus.vue?vue&type=style&index=0&id=0e2b2264&lang=scss"
script.render = render

export default script